import clsx from "clsx";
import { PropsWithChildren } from "react";

type TabContainerProps = {
  className?: string;
};

export function TabContainer(props: PropsWithChildren<TabContainerProps>) {
  return (
    <div
      className={clsx(
        "border-gray-950 bg-gray-950 inline-flex gap-1 rounded-full border p-1 dark:border-white",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}
